import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { useQueryMutation } from '@lore/query-connect';
import validators from '../../utils/validators';
import Overlay from '../../forms/_common/Overlay';
import FormErrors from '../../forms/_common/FormErrors';
import RequestError from '../../forms/_common/RequestError';
import ErrorMessage from '../../forms/_common/ErrorMessage';
import SuccessMessage from '../../forms/_common/SuccessMessage';
import DialogTemplate from '../../dialogs_common/DialogTemplate';
import Form from './Form';
import Confirmation from './Confirmation';
import Blocker from './Blocker';

export default function ReminderDialogTemplate(props) {
  const {
    title,
    subtitle,
    reminders,
    _data,
    MAX_COUNT,
    blockerText
  } = props;

  const [data, setData] = useState({
    // type: undefined,
    // questionId: question.id,
    // userId: undefined
  });
  const [showErrors, setShowErrors] = useState(false);

  const mutation = useQueryMutation('reminder.create');
  const { saving, success, error, request } = mutation;

  useEffect(() => {
    if (success) {
      // props.onClose();
      // props.onSubmit && props.onSubmit(request);
    }
  }, [success]);

  function onSubmit(_data) {
    mutation.mutate(_data, {
      onSuccess: payload => reminders._add(payload)
    });
  }

  function onChange(name, value) {
    const nextData = _.merge({}, data);
    nextData[name] = value;
    setData(nextData);
  }

  return (
    <DialogTemplate>
      <Overlay isVisible={saving}>
        <FormErrors data={data} validators={{
          // text: [validators.isRequired]
        }}>
          {({errors, hasError}) => {
            if (blockerText) {
              return (
                <Blocker
                  title={title}
                  subtitle={subtitle}
                  blockerText={blockerText}
                  onClose={props.onClose}
                />
              );
            }

            if (success) {
              return (
                <Confirmation
                  onClose={props.onClose}
                />
              );
            }

            return (
              <Form
                title={title}
                subtitle={subtitle}
                reminders={reminders}
                _data={_data}
                MAX_COUNT={MAX_COUNT}

                data={data}
                errors={errors}
                showErrors={showErrors}
                onChange={onChange}
                onSubmit={(_data) => hasError ? setShowErrors(true) : onSubmit(_data)}
                onClose={props.onClose}
                alert={error ? (
                  <RequestError request={request}/>
                ) : showErrors ? (
                  <ErrorMessage>
                    Please fill in all required fields.
                  </ErrorMessage>
                ) : (false && success) ? (
                  <SuccessMessage>
                    Idea created.
                  </SuccessMessage>
                ) : null}
              />
            );
          }}
        </FormErrors>
      </Overlay>
    </DialogTemplate>
  );
};
